var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.387 19c-.376 0-.626-.124-.877-.373l-6.134-6.46c-.501-.496-.501-1.242 0-1.739a1.217 1.217 0 0 1 1.752 0l5.134 5.466L19.778 4.465c.376-.497 1.252-.621 1.753-.248.501.372.626 1.242.25 1.739l-.125.124-11.393 12.423c-.125.373-.5.497-.876.497"
  })));
};
export { SvgCheckmark as ReactComponent };
export default __webpack_public_path__ + "b97fd696ca3a7f3d39e9a2c16faba75d.svg";